import React, { PropsWithChildren } from 'react';
import {
  FieldValues,
  FormProvider as Form,
  UseFormReturn,
} from 'react-hook-form';

export type FormProviderProps<T extends FieldValues> = PropsWithChildren<{
  methods: UseFormReturn<T>;
  onSubmit?: (e: React.FormEvent) => void;
  id?: string;
  style?: React.CSSProperties;
}>;

export default function FormProvider<T extends FieldValues = any>({
  children,
  onSubmit,
  methods,
  id,
  style,
}: FormProviderProps<T>) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} id={id} style={style}>
        {children}
      </form>
    </Form>
  );
}
